const FLEXWORK_ADMIN_ROLE_ID = '32413644-31cf-48b7-8983-b911060154f4';
const FLEXWORK_MANAGER_ROLE_ID = '52766db1-fdb1-4912-baac-f942cf5e9da9';
const FLEXWORK_SIGNER_ROLE_ID = '83bc10b5-adc2-42eb-ae39-67b3a5f9e39c';

export const FLEXWORK_ROLES = {
  FLEXWORK_ADMIN: FLEXWORK_ADMIN_ROLE_ID,
  FLEXWORK_MANAGER: FLEXWORK_MANAGER_ROLE_ID,
  FLEXWORK_SIGNER: FLEXWORK_SIGNER_ROLE_ID,
};
